import { BaseBadge, SmallBaseBadge } from "./BaseBadge";
import { BadgeProps } from "./types";
import "../../designTokens/variables.css";

export const GammaBadge = (props: BadgeProps) => {
  return <BaseBadge backgroundColor="var(--color-error-500)" {...props} />;
};

export const SmallGammaBadge = (props: BadgeProps) => {
  return <SmallBaseBadge backgroundColor="var(--color-error-500)" {...props} />;
};
